<template>
  <div>
    <v-container fluid class="px-4 py-4">
      <!-- Top Row with Welcome Card and Weather -->
      <v-row>
        <v-col cols="12">
          <v-card class="border-radius-xl card-shadow">
            <div class="px-4 py-4">
              <h1 class="text-h4 font-weight-bold mb-1">公司儀表板</h1>
              <p class="text-subtitle-1 text-medium-emphasis">
                歡迎回來，查看公司最新數據和統計信息
              </p>

              <v-alert
                v-if="dashboardError"
                type="warning"
                text
                dense
                class="mt-4 mb-0"
              >
                {{ dashboardError }}
              </v-alert>

              <!-- Key Metrics Row -->
              <v-row class="mt-4">
                <v-col
                  md="3"
                  sm="6"
                  cols="12"
                  @click="
                    canEditRole ? $router.push('/pages/users/users') : null
                  "
                  :style="canEditRole ? 'cursor: pointer;' : ''"
                  :class="canEditRole ? 'hover-scale' : ''"
                >
                  <div class="d-flex align-center">
                    <div
                      class="rounded-circle bg-gradient-primary p-6 mr-4"
                      style="
                        height: 48px;
                        width: 48px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <v-icon color="white">mdi-account-group</v-icon>
                    </div>
                    <div>
                      <p class="text-sm text-medium-emphasis mb-0">員工總數</p>
                      <h3 class="font-weight-bold mb-0">
                        {{
                          dashboardLoading
                            ? "--"
                            : dashboardSummary.employee_num
                        }}
                      </h3>
                    </div>
                  </div>
                </v-col>

                <v-col
                  md="3"
                  sm="6"
                  cols="12"
                  @click="$router.push('/pages/dashboards/clock-records')"
                  style="cursor: pointer"
                  class="hover-scale"
                >
                  <div class="d-flex align-center">
                    <div
                      class="rounded-circle bg-gradient-success p-6 mr-4"
                      style="
                        height: 48px;
                        width: 48px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <v-icon color="white">mdi-calendar-check</v-icon>
                    </div>
                    <div>
                      <p class="text-sm text-medium-emphasis mb-0">今日出勤</p>
                      <h3 class="font-weight-bold mb-0">
                        {{
                          dashboardLoading
                            ? "--"
                            : dashboardSummary.today_attendance_count
                        }}
                      </h3>
                    </div>
                  </div>
                </v-col>

                <v-col
                  md="3"
                  sm="6"
                  cols="12"
                  @click="$router.push('/pages/users/leave-management?tab=1')"
                  style="cursor: pointer"
                  class="hover-scale"
                >
                  <div class="d-flex align-center">
                    <div
                      class="rounded-circle bg-gradient-warning p-6 mr-4"
                      style="
                        height: 48px;
                        width: 48px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <v-icon color="white">mdi-clock-outline</v-icon>
                    </div>
                    <div>
                      <p class="text-sm text-medium-emphasis mb-0">待審批</p>
                      <h3 class="font-weight-bold mb-0">
                        {{
                          dashboardLoading
                            ? "--"
                            : dashboardSummary.pending_approval_count
                        }}
                      </h3>
                    </div>
                  </div>
                </v-col>

                <v-col md="3" sm="6" cols="12" v-show="false">
                  <div class="d-flex align-center">
                    <div
                      class="rounded-circle bg-gradient-info p-6 mr-4"
                      style="
                        height: 48px;
                        width: 48px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <v-icon color="white">mdi-chart-timeline-variant</v-icon>
                    </div>
                    <div>
                      <p class="text-sm text-medium-emphasis mb-0">
                        進行中專案
                      </p>
                      <h3 class="font-weight-bold mb-0">12</h3>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Middle Row with Statistics Cards -->
      <v-row class="mt-2" v-if="false">
        <v-col lg="3" md="6" sm="6" cols="12">
          <v-card class="border-radius-xl card-shadow">
            <div class="px-6 py-6 text-center">
              <h1 class="text-gradient text-success font-weight-bolder text-h1">
                <span>92</span>
                <span class="text-lg">%</span>
              </h1>
              <h6 class="mb-0 text-h6 font-weight-bolder text-typo">
                員工滿意度
              </h6>
              <p class="opacity-8 mb-0 text-sm text-typo">本季度調查結果</p>
            </div>
          </v-card>
        </v-col>

        <v-col lg="3" md="6" sm="6" cols="12">
          <v-card class="border-radius-xl card-shadow">
            <div class="px-6 py-6 text-center">
              <h1 class="text-gradient text-primary font-weight-bolder text-h1">
                <span>14</span>
                <span class="text-lg">天</span>
              </h1>
              <h6 class="mb-0 text-h6 font-weight-bolder text-typo">
                平均請假時間
              </h6>
              <p class="opacity-8 mb-0 text-sm text-typo">年度統計</p>
            </div>
          </v-card>
        </v-col>

        <v-col lg="3" md="6" sm="6" cols="12">
          <v-card class="border-radius-xl card-shadow">
            <div class="px-6 py-6 text-center">
              <h1 class="text-gradient text-info font-weight-bolder text-h1">
                <span>8</span>
                <span class="text-lg">%</span>
              </h1>
              <h6 class="mb-0 text-h6 font-weight-bolder text-typo">
                員工流動率
              </h6>
              <p class="opacity-8 mb-0 text-sm text-typo">過去12個月</p>
            </div>
          </v-card>
        </v-col>

        <v-col lg="3" md="6" sm="6" cols="12">
          <v-card class="border-radius-xl card-shadow">
            <div class="px-6 py-6 text-center">
              <h1 class="text-gradient text-warning font-weight-bolder text-h1">
                <span>24</span>
                <span class="text-lg">小時</span>
              </h1>
              <h6 class="mb-0 text-h6 font-weight-bolder text-typo">
                平均加班時間
              </h6>
              <p class="opacity-8 mb-0 text-sm text-typo">本月統計</p>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Bottom Row with Department Performance and Recent Activities -->
      <v-row class="mt-2">
        <v-col lg="6" cols="12">
          <!-- Today's Attendance Records -->
          <AttendanceRecords :date="currentDate" :pageSize="10" />
        </v-col>
        <v-col lg="6" cols="12">
          <v-card class="border-radius-xl card-shadow">
            <div class="pb-0 px-4 pt-4">
              <h6 class="text-h6 text-typo mb-0 font-weight-bold">最近活動</h6>
            </div>
            <div class="px-4 py-4">
              <div
                v-for="(activity, index) in recentActivities"
                :key="index"
                class="timeline-item mb-4 hover-scale"
                style="cursor: pointer"
                @click="openActivity(activity)"
              >
                <div class="d-flex">
                  <div
                    class="timeline-icon mr-3"
                    :class="`bg-gradient-${activity.color}`"
                  >
                    <v-icon size="16" color="white">{{ activity.icon }}</v-icon>
                  </div>
                  <div class="flex-grow-1">
                    <div class="d-flex justify-space-between">
                      <h6 class="text-sm font-weight-bold mb-0">
                        {{ activity.title }}
                      </h6>
                      <p class="text-xs text-medium-emphasis mb-0">
                        {{ activity.time }}
                      </p>
                    </div>
                    <p class="text-sm mb-0">{{ activity.description }}</p>
                    <p class="text-xs text-medium-emphasis mb-0">
                      {{ activity.user }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AttendanceRecords from "@/components/Widgets/AttendanceRecords.vue";
import { mapGetters } from "vuex";

const createDefaultDashboardSummary = () => ({
  employee_num: 0,
  today_attendance_count: 0,
  pending_approval_count: 0,
});

export default {
  name: "CompanyDashboard",
  components: {
    AttendanceRecords,
  },
  computed: {
    ...mapGetters("company", ["selectedCompany"]),
    ...mapGetters("user", ["canEditRole"]),
  },
  data() {
    return {
      currentDate: new Date().toLocaleDateString("en-CA", {
        timeZone: "Asia/Taipei",
      }),
      dashboardSummary: createDefaultDashboardSummary(),
      dashboardLoading: false,
      dashboardError: null,
      recentActivities: [],
    };
  },
  watch: {
    selectedCompany: {
      immediate: true,
      handler(newCompany) {
        if (!newCompany || !newCompany.id) {
          this.dashboardSummary = createDefaultDashboardSummary();
          this.recentActivities = [];
          this.dashboardError = null;
          return;
        }

        this.fetchDashboardSummary();
        this.fetchRecentActivities();
      },
    },
  },
  methods: {
    async fetchDashboardSummary() {
      if (!this.selectedCompany || !this.selectedCompany.id) {
        this.dashboardSummary = createDefaultDashboardSummary();
        return;
      }

      this.dashboardLoading = true;
      this.dashboardError = null;

      try {
        const response = await this.$axios.get(
          `/api/companies/${this.selectedCompany.id}/dashboard`
        );
        const summary = response.data?.data || {};
        this.dashboardSummary = {
          employee_num: Number(summary.employee_num ?? 0),
          today_attendance_count: Number(summary.today_attendance_count ?? 0),
          pending_approval_count: Number(summary.pending_approval_count ?? 0),
        };
      } catch (error) {
        console.error("Error fetching company dashboard:", error);
        this.dashboardSummary = createDefaultDashboardSummary();
        this.dashboardError = "無法載入公司儀表板資料";
      } finally {
        this.dashboardLoading = false;
      }
    },
    async fetchRecentActivities() {
      if (!this.selectedCompany) {
        this.recentActivities = [];
        return;
      }
      try {
        const response = await this.$axios.get("/api/messages", {
          params: {
            company_id: this.selectedCompany.id,
            page: 1,
            limit: 5,
            all: 0,
          },
        });
        console.log(response.data.data);
        this.recentActivities = response.data.data.map((msg) => ({
          title: msg.title,
          description: msg.body,
          user: msg.initiator && msg.initiator.name ? msg.initiator.name : "",
          time: this.formatTime(msg.create_time),
          icon: this.getIcon(msg.action_type),
          color: this.getColor(msg.action_type),
          link: msg.link,
        }));
      } catch (error) {
        console.error("Error fetching recent activities:", error);
        this.recentActivities = [];
      }
    },
    openActivity(activity) {
      if (!activity.link) return;

      const applicationMatch = activity.link.match(/^\/applications\/(\d+)$/);
      if (applicationMatch) {
        this.$router.push({
          path: "/pages/users/leave-management",
          query: {
            tab: "0",
            application_id: applicationMatch[1],
          },
        });
        return;
      }

      this.$router.push(activity.link);
    },
    formatTime(createTime) {
      const now = new Date();
      const created = new Date(createTime);
      const diffMs = now - created;
      const diffMins = Math.floor(diffMs / (1000 * 60));
      const diffHours = Math.floor(diffMins / 60);
      const diffDays = Math.floor(diffHours / 24);

      if (diffMins < 60) {
        return `${diffMins}分鐘前`;
      } else if (diffHours < 24) {
        return `${diffHours}小時前`;
      } else {
        return `${diffDays}天前`;
      }
    },
    getIcon(type) {
      switch (type) {
        case 1: // LEAVE
          return "mdi-calendar-clock";
        case 2: // OVERTIME
          return "mdi-clock-outline";
        case 3: // SHIFT
          return "mdi-swap-horizontal";
        case 4: // CLOCK
          return "mdi-clock";
        case 5: // TRAVEL
          return "mdi-airplane";
        case 6: // OUT
          return "mdi-door-open";
        case 7: // QUIT
          return "mdi-account-remove";
        case 10: // ANNOUNCEMENT
          return "mdi-bullhorn";
        case 11: // NEW_USER
          return "mdi-account-plus";
        default:
          return "mdi-bell";
      }
    },
    getColor(type) {
      switch (type) {
        case 1: // LEAVE
          return "warning";
        case 2: // OVERTIME
          return "error";
        case 3: // SHIFT
          return "default";
        case 4: // CLOCK 補打卡
          return "info";
        case 11: // NEW_USER
          return "success";
        default:
          return "primary";
      }
    },
  },
};
</script>

<style scoped>
.border-radius-xl {
  border-radius: 12px;
}

.card-shadow {
  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05);
}

.text-gradient.text-success {
  background-image: linear-gradient(310deg, #2dce89, #26a69a);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.text-gradient.text-primary {
  background-image: linear-gradient(310deg, #5e72e4, #825ee4);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.text-gradient.text-info {
  background-image: linear-gradient(310deg, #1171ef, #11cdef);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.text-gradient.text-warning {
  background-image: linear-gradient(310deg, #fb6340, #fbb140);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.bg-gradient-primary {
  background-image: linear-gradient(310deg, #5e72e4, #825ee4);
}

.bg-gradient-success {
  background-image: linear-gradient(310deg, #2dce89, #26a69a);
}

.bg-gradient-info {
  background-image: linear-gradient(310deg, #1171ef, #11cdef);
}

.bg-gradient-warning {
  background-image: linear-gradient(310deg, #fb6340, #fbb140);
}

.bg-gradient-error {
  background-image: linear-gradient(310deg, #f5365c, #f56036);
}

.rounded-circle {
  border-radius: 50% !important;
}

.timeline-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.timeline-item {
  position: relative;
}

.timeline-item:not(:last-child)::after {
  content: "";
  position: absolute;
  left: 16px;
  top: 32px;
  height: calc(100% - 32px);
  width: 1px;
  background-color: #e9ecef;
}

.hover-scale {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.hover-scale:hover {
  transform: translateY(-2px);
  opacity: 0.9;
}
</style>
